import { render } from "./PartnerRender.vue?vue&type=template&id=4a3c9e26&scoped=true"
import script from "./PartnerRender.vue?vue&type=script&lang=js"
export * from "./PartnerRender.vue?vue&type=script&lang=js"

import "./PartnerRender.vue?vue&type=style&index=0&id=4a3c9e26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3c9e26"]])

export default __exports__